import { plainToInstance, instanceToPlain } from 'class-transformer';

function plainToClass(Class, plain) {
    return plainToInstance(Class, plain, {
        enableImplicitConversion: false,
        exposeUnsetFields: false
    });
}
function classToPlain(plain) {
    return instanceToPlain(plain, {
        strategy: "excludeAll",
        enableImplicitConversion: false
    });
}

export { classToPlain as c, plainToClass as p };
//# sourceMappingURL=classes_chunkExport-DIIf8JYD.mjs.map
